module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-solar.png?68860150ba6780645e0c4c4623f0503d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-solar.png
// module id = 1048
// module chunks = 1